import { render, staticRenderFns } from "./PlotCreateDialog.vue?vue&type=template&id=0124bc59&scoped=true"
import script from "./PlotCreateDialog.vue?vue&type=script&lang=ts"
export * from "./PlotCreateDialog.vue?vue&type=script&lang=ts"
import style0 from "./PlotCreateDialog.vue?vue&type=style&index=0&id=0124bc59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0124bc59",
  null
  
)

export default component.exports